export class Corporation {
    constructor(corporation) {
        this.id = corporation.id;
        this.logo = corporation.logo;
        this.website_url = corporation.website_url;
    }
}